import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './Styles';
import history from '../../browserHistory';
const Logo = ({ url, alt, width }) => {
  const handleDashboardClick = () => {
    if (history.location.pathname.includes('dashboard')) {
      window.location.reload();
    } else {
      history.push('/dashboard');
    }
  };
  return (
    <Container>
      <img
        data-testid="logo"
        src={url}
        alt={alt}
        width={width}
        onClick={handleDashboardClick}
        style={{ cursor: 'pointer' }}
      />
    </Container>
  );
};

Logo.propTypes = {
  url: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.string,
};

Logo.defaultProps = {
  width: '100%',
};

export default Logo;
